import { render, staticRenderFns } from "./AddressProfile.vue?vue&type=template&id=58b5ae69&scoped=true"
import script from "./AddressProfile.vue?vue&type=script&lang=js"
export * from "./AddressProfile.vue?vue&type=script&lang=js"
import style0 from "./AddressProfile.vue?vue&type=style&index=0&id=58b5ae69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5ae69",
  null
  
)

export default component.exports